/**
 * External dependencies
 */
import classnames from "classnames";

/**
 * WordPress dependencies
 */
import { __ } from "@wordpress/i18n";
import { Modal } from "@wordpress/components";
import { useState, useCallback, useMemo } from "@wordpress/element";
import icons from "./icons.json";
import "./index.scss";

/**
 * Internal dependencies
 */
import IconList from "./icon-list";
import ModalHeader from "./modal-header";
import Sidebar from "./sidebar";

export default function IconsModal(props) {
  const {
    isIconsModalOpen,
    setIsIconsModalOpen,
    icon,
    setAttributes,
    iconStyle = true,
  } = props;

  const [searchInput, setSearchInput] = useState("");
  const [iconType, setIconType] = useState(icon?.type || "regular");

  // Move the filtering logic to a separate function
  const getFilteredIcons = useCallback(() => {
    if (searchInput) {
      return icons.filter((key) => {
        const input = searchInput.toLowerCase();

        if (key.includes(input)) {
          return true;
        }

        return false;
      });
    }

    return icons;
  }, [searchInput, iconType]);

  if (!isIconsModalOpen) {
    return null;
  }

  function updateIconAtts(name) {
    const newIconAttribute = {
      name: name,
    };
    if (iconStyle) {
      newIconAttribute.type = iconType;
    }
    setAttributes(newIconAttribute);
    setIsIconsModalOpen(false);
  }

  const handleIconTypeChange = (type) => {
    setIconType(type);
    setAttributes({
      type: type,
    });
  };

  return (
    <Modal
      className="brandy-icon-inserter__modal"
      title={__("Icon Library")}
      onRequestClose={() => setIsIconsModalOpen(false)}
      isFullScreen
    >
      <div
        className={classnames("icon-inserter", {
          "is-searching": searchInput,
        })}
      >
        <Sidebar searchInput={searchInput} setSearchInput={setSearchInput} />
        <div className="icon-inserter__content">
          {iconStyle && (
            <ModalHeader
              iconType={iconType}
              handleIconTypeChange={handleIconTypeChange}
            />
          )}
          <IconList
            icon={icon}
            shownIcons={getFilteredIcons()}
            updateIconAtts={updateIconAtts}
          />
        </div>
      </div>
    </Modal>
  );
}
